module.exports = __webpack_public_path__ + "4a0eb3377ca6c6ad99dc2a2b1b00626d.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/spacemarines-vignette-preview-460.webp.png
// module id = 550
// module chunks = 0